module.exports = __webpack_public_path__ + "static/thumb-seamoss-4b5518eca9a723a5b8ebddcc084cc910.png";